import { useMutation } from '@tanstack/react-query';

import { addSelectedProductToApl } from 'services/apl';

export const useAddSelectedProductToApl = () => {
  return useMutation({
    mutationKey: 'add-selected-product-to-apl',
    mutationFn: addSelectedProductToApl,
  });
};
